import API from "../../../app/api";

export const getLetsFindYourFloorBestFind = async () => {
  try {
    const res = await API.get(
      "/banners/section/LETS_FIND_YOUR_FLOORS_BEST_FRIEND"
    );

    if (!res.data?.success) {
      throw new Error(
        res.data?.message || "Failed to fetch Lets Find Your Floor"
      );
    }

    // ✅ API returns data.banners
    return res.data?.data?.banners || [];
  } catch (error) {
    console.error("getLetsFindYourFloorBestFind error:", error);
    return [];
  }
};